/**
 * DetailTabs — secondary tab bar used inside a right detail panel.
 * Lighter visual weight than HubShell's primary tab bar.
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { colors, fonts } from './colors';

export interface DetailTab {
  key: string;
  label: string;
  icon?: IconDefinition;
  badge?: number | string | null;
}

interface DetailTabsProps {
  tabs: DetailTab[];
  activeTab: string;
  onChange: (key: string) => void;
}

const DetailTabs: React.FC<DetailTabsProps> = ({ tabs, activeTab, onChange }) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '4px',
        padding: '0 24px',
        marginBottom: '12px',
        borderBottom: `1px solid ${colors.border}`,
        overflowX: 'auto',
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.key === activeTab;
        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            style={{
              background: isActive ? colors.white : 'transparent',
              border: 'none',
              borderBottom: `3px solid ${isActive ? colors.gold : 'transparent'}`,
              color: isActive ? colors.navy : '#6b7280',
              padding: '10px 16px',
              fontSize: '13px',
              fontWeight: 600,
              fontFamily: fonts.body,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              whiteSpace: 'nowrap',
              borderRadius: '6px 6px 0 0',
              marginBottom: '-1px',
            }}
          >
            {tab.icon && <FontAwesomeIcon icon={tab.icon} style={{ fontSize: '12px' }} />}
            <span>{tab.label}</span>
            {tab.badge != null && tab.badge !== '' && (
              <span
                style={{
                  background: isActive ? colors.gold : '#e5e7eb',
                  color: isActive ? colors.navy : '#6b7280',
                  fontSize: '10px',
                  fontWeight: 700,
                  padding: '2px 6px',
                  borderRadius: '10px',
                }}
              >
                {tab.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default DetailTabs;
